// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-input--checkbox[data-v-e672f95e] .v-label{margin:0!important}", ""]);
// Exports
module.exports = exports;
